import React from 'react';

import type { EdgeSide, EdgeState } from '../engine';

import { FeedSkeletonRow } from './BootSkeleton';

/** Renders a feed edge sentinel plus loading or retry affordance for one rail. */
export function FeedEdgeZone({
  onRetry,
  register,
  side,
  state
}: {
  readonly onRetry: () => void;
  readonly register: (el: HTMLDivElement | null) => void;
  readonly side: EdgeSide;
  readonly state: EdgeState[EdgeSide];
}) {
  return (
    <div
      className="absolute right-0 left-0 top-0 flex h-32 items-center justify-center px-4 text-xs font-medium text-gray-500 dark:text-neutral-500"
      data-edge-state={state}
      data-edge-zone={side}
      ref={register}
    >
      {state === 'loading' ? <EdgeShimmer /> : null}
      {state === 'error' ? (
        <button className="cursor-pointer rounded-md bg-gray-100 px-3 py-1.5 text-xs text-gray-700 dark:bg-neutral-800 dark:text-neutral-200" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}

function EdgeShimmer() {
  return (
    <div className="flex w-full max-w-2xl flex-col gap-2 opacity-50" aria-hidden="true" data-feed-edge-skeleton>
      <FeedSkeletonRow />
      <FeedSkeletonRow width="narrow" />
    </div>
  );
}
